import {Stack} from '@mui/material';

import {ApplicantMatchCard} from './ApplicantMatchCard';
import {Match} from '../../types/ApplicantMatchesTypes';

interface Props {
  matches: Match[];
}

export const ApplicantMatchesMobileList = ({matches}: Props) => (
  <Stack spacing={1.5}>
    {matches.map((match) => (
      <ApplicantMatchCard key={match.resourceId} match={match} />
    ))}
  </Stack>
);
